
module.exports = {
   
    baseUrl: "https://hos.keoliscs.com",
    
    msalConfig : {
        
        auth: {
            clientId: "1ae1debd-bc8a-4881-8d44-ea01afe5ff39",
            authority: "https://login.microsoftonline.com/7124e463-2734-41bf-bddb-3e475374f94c",
            redirectUri: "/",
            navigateToLoginRequestUrl:false
        }

        ,
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
        },
       
    },
    loginRequest : {
        scopes: ["openid", "profile", "User.Read"]
    },
    tokenForGraph : {
        scopes: ["User.Read"],
        forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
    },
    tokenForAPI: {
        scopes: ["api://1ae1debd-bc8a-4881-8d44-ea01afe5ff39/Employee.Read"],        
        forceRefresh: false
    },
    graphEndPoint: "https://graph.microsoft.com/v1.0/me?$select=id,displayName,givenName,jobTitle,mail,mobilePhone,userPrincipalName,employeeId",
    graphRoleEndPoint: "https://graph.microsoft.com/v1.0/me/memberOf?$top=250&$select=id,displayName"    
 
}